import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { IconButton } from "@chakra-ui/react";
import { PopoverCard, Title } from "../../Components/Atoms";
import Report from "../Report";

import { DownloadIcon } from "../../Assets/images/svgs";
import { getVehicleStats } from "../../APIs";
import { ReactTable } from "../../Components/Molecules";

import { getUserAndVehicle } from "../../Library/helpers";
import { DATE_RANGES } from "../../Library/constants";
import { StoreContext } from "../../Library/contexts";
import { EV_STAT_HEADERS } from "../../Library/tableHeaders";

const Tabular = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let [ searchParams ] = useSearchParams();

  const { filters } = useContext(StoreContext);

  const [ tableData, setTableData ] = useState(null);
  const [ showOverlay, setShowOverlay ] = useState(false);

  useEffect(() => {
    if (!location.state) return;

    const init = async () => {
      let qs = {};
      if (location.state.typ) qs.typ = location.state.typ;
      if (searchParams.has('faultId')) qs.faultId = searchParams.get('faultId');
      if (location.state.model) qs.md = location.state.model;

      const response = await getVehicleStats(DATE_RANGES[filters.range], location.state.fault, qs);
      setTableData(getUserAndVehicle(response));
    };

    init();
  }, [ filters, location.state, navigate, searchParams ]);

  const removePopover = (toggle) => {
    if (toggle) setShowOverlay((old) => !old);
    else setShowOverlay(false);
  };

  const columns = React.useMemo(() => {
    if (!location.state) return;
    let tableHeaders = EV_STAT_HEADERS[location.state.fault]?.headers || {};
    if (location.state.hideThresholdCrossed) {
      let newHeaders = {...tableHeaders};
      delete newHeaders.faults;
      tableHeaders = newHeaders;
    }
    return Object.values(tableHeaders).map(header => {
      return {
        Header: header.nm === "Faults" ? "Times of threshold crossed" : header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        Cell: (row) => (header.popoverCard && row.value && row.value.length) ? (
          <PopoverCard
            data={row.value.length}
            cardTitle="Dates of fault identified"
            array={row.value}
            removePopover={removePopover}
            dateTime={true}
          />
        ) : row.value || "-",
      };
    })
  }, [ location.state ]);

  if (!location.state) return <Navigate to="/" />;
  const { title, paths } = location.state;

  return (
    <Report breadcrumb={paths}>
      <div className="panel-chart-header">
        <Title>{title}</Title>
        <IconButton
          className="panel-button"
          height={"100%"}
          aria-label='Download Report'
          icon={<DownloadIcon />}
        />
      </div>

      {!!tableData && (
        <div className="panel-chart-table">
          <ReactTable
            columns={columns}
            data={tableData}
            showSearch={true}
            showOverlay={showOverlay}
            pageSize={8}
          />
        </div>
      )}
    </Report>
  );
};

export default Tabular;
